import { ThreeDots } from "react-loader-spinner";
import cancelImage from "../assets/images/cancel.png";
import { useDeleteCompletedTodoMutation, useToggleTodoStatusMutation } from "../features/api/apiSlice";

export default function CompletedTodo({ todo }) {
    const [handleDeleteTodo, { isLoading: deleteLoading }] = useDeleteCompletedTodoMutation();
    const [handleUpdateTodo, { isLoading: toggleLoading }] = useToggleTodoStatusMutation();

    const { text, id, completed, color } = todo;

    const handleStatusChange = () => {
        !toggleLoading && handleUpdateTodo({ id, body: { ...todo, completed: !completed } })
    };

    const handleDelete = () => {
        handleDeleteTodo(id);
    };

    return (
        <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
            <div
                className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 border-green-500 focus-within:border-green-500`}
            >
                <input
                    type="checkbox"
                    checked={completed}
                    onChange={handleStatusChange}
                    className="opacity-0 absolute rounded-full cursor-pointer"
                />

                <svg
                    className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                    viewBox="0 0 20 20"
                >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>

            </div>

            <div
                className={`select-none flex-1 line-through`}
            >{text}
            </div>
            {
                (deleteLoading || toggleLoading) ? <ThreeDots
                    height="20"
                    width="20"
                    radius="9"
                    color="red"
                    ariaLabel="three-dots-loading"
                    visible={true}
                />
                    : <>
                        <div
                            className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto border-green-500 ${color === "green" && "bg-green-500"
                                }`}
                        ></div>

                        <div
                            className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto border-yellow-500 ${color === "yellow" && "bg-yellow-500"
                                }`}
                        ></div>

                        <div
                            className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto border-red-500 ${color === "red" && "bg-red-500"
                                }`}
                        ></div>
                        <img
                            src={cancelImage}
                            className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                            alt="Cancel"
                            onClick={handleDelete}
                        />
                    </>
            }

        </div>
    );
}
